import { IoCreateOutline } from 'react-icons/io5';

import { ButtonSmall } from '@/components/Button';

import s from './SafetyFooterSection.module.scss';

interface SafetyFooterSectionProps {
  date: string;
  captainName: string;
  captainSignedAt: string;
  canSign: boolean;
  canSubmitSign: boolean;
  isSigning: boolean;
  onSign(): void;
}

const formatDate = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso || '-';
  return d.toLocaleDateString('en-GB');
};

const formatSignedAt = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const dateStr = d.toLocaleDateString('en-GB');
  const timeStr = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return `${dateStr} · ${timeStr}`;
};

export function SafetyFooterSection({
  date,
  captainName,
  captainSignedAt,
  canSign,
  canSubmitSign,
  isSigning,
  onSign,
}: SafetyFooterSectionProps) {
  return (
    <div className={s.root}>
      <div className={s.signatureCell}>
        <div className={s.header}>
          <span className={s.headerIcon}>
            <IoCreateOutline aria-hidden="true" />
          </span>
          <span className={s.headerTitle}>Captain’s Signature</span>
        </div>
        {captainSignedAt ? (
          <div className={s.signed}>
            <div className={s.checkmark}>✓</div>
            <div>
              <div className={s.signedBy}>{captainName || 'Master'}</div>
              <div className={s.signedAt}>{formatSignedAt(captainSignedAt)}</div>
            </div>
          </div>
        ) : (
          canSign && (
            <ButtonSmall onClick={onSign} disabled={!canSubmitSign || isSigning}>
              {isSigning ? 'Signing…' : 'Sign & Save'}
            </ButtonSmall>
          )
        )}
      </div>

      <div className={s.dateCell}>
        <span className={s.label}>Date</span>
        <span className={s.value}>{formatDate(date)}</span>
      </div>
    </div>
  );
}
